import { useEffect, useState } from 'react';
import {
    ActionIcon,
   // Anchor,
    Button,
    Checkbox,
    Container,
    Drawer,
    DrawerProps,
    Flex,
    Group,
    Loader,
    NumberInput,
    Paper,
    PaperProps,
    Popover,
    Radio,
    ScrollArea,
    Select,
    Slider,
    Stack,
    Text,
    TextInput,
   // ThemeIcon,
    Transition,
    useMantineTheme,
} from "@mantine/core";
import {
    IconBrandApple,
    IconBrandGoogle,
    IconCreditCard,
    IconCurrencyDollar,
    IconInfoCircleFilled,
   // IconShieldCheckFilled,
    
} from "@tabler/icons-react";
import { makeGetRequest, makePostRequest } from '../services/httpHelper';
import { isErrorObject } from '../utils/utils';
import ErrorHandler from '../services/ErrorHandler';
import { ICurrency,ICampaign,IPaymentMethod,IBank } from '../types';
import { Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FaPaypal } from 'react-icons/fa';
import PaystackPop from '@paystack/inline-js';
import { isEmail } from '../utils/FormValidator';






interface IProps extends Pick<DrawerProps, 'opened' | 'onClose' | 'size'> {
    campaign?: ICampaign;
    iconSize: number;
}

const DonationDrawer = ({ campaign, iconSize, ...others }: IProps) => {
    const [payment, setPayment] = useState('');
    const [supportedCurrencies, setSupportedCurrencies] = useState<ICurrency[]>([]);
    const [paymentMethods, setPaymentMethods] = useState<IPaymentMethod[]>([]);
    const [banks, setBanks] = useState<IBank[]>([]);
    const [currentPaymentMethod, setCurrentPaymentMethod] = useState('M-PESA');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState('KES');
    const [selectedBank, setSelectedBank] = useState('');
    const [donationAmount, setDonationAmount] = useState(100);
    const [tipPercentage, setTipPercentage] = useState(0);
    const [serviceFee] = useState(0.035);
    const [tipAmount, setTipAmount] = useState(0);
    const [isAnonymous, setIsAnonymous] = useState(false);
    const [getUpdates, setGetUpdates] = useState(true);
    const[campaignSubAccount,setCampaignSubAccount]=useState(null)

    const [showGuestForm, setShowGuestForm] = useState(true);
    const [isFailed, setIsFailed] = useState(false);
    const [retryUrl, setRetryUrl] = useState(null);


    const [userDetails, setUserDetails] = useState({
        email: '',
        firstName: '',
        lastName: '',
        mobileNumber: '',
        cardNumber: 0,
        cardExpiry: '',
        cardCvv: 0,
        cardName: '',
        postalCode: '',
        accountName:'',
        accountNumber:'',
    });
  


    const theme = useMantineTheme();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isUserLoggedIn = !!user.id;

    const paperProps: PaperProps = {
        p: "md",
        withBorder: true,
        sx: { backgroundColor: theme.white },
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setUserDetails(prevState => ({ ...prevState, [name]: value }));
    };

    /*const handleNumberChange = (value: number | any, name: string) => {
        setUserDetails(prevState => ({ ...prevState, [name]: value ?? 0 }));
    };*/

    const handleDonationAmountChange = (value: number | any) => {
        const amount = value ?? 0;
        setDonationAmount(amount);
        
    };
    const handlePresetClick = (amount:number |any) => {
        setDonationAmount(amount);
      };

    const handleTipAmountChange = (value: number) => {
    setTipPercentage(value );        
    };

    const handlePaymentMethodChange = (paymentMethodId: string) => {
        const selectedPaymentMethod = paymentMethods.filter((paymentMethod:IPaymentMethod)=>paymentMethod.id===paymentMethodId);
        setPayment(paymentMethodId)

        setSupportedCurrencies(selectedPaymentMethod[0].currencies);
        setCurrentPaymentMethod(selectedPaymentMethod[0].payment_service)

      
    };

    const handleCurrencyChange = (value: string) => {
        setSelectedCurrency(value);
      
    };

    const handleBankChange = (value: string) => {
        setSelectedBank(value);
     
    };

 

    const checkPaymentStatus = async(transactionId:any) => {
        const interval = setInterval(async() => {
          const res = await makeGetRequest(`check-payment-status/${transactionId}`);
          if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
            clearInterval(interval);

        }
         else if (res.data.status === 'success') {
            clearInterval(interval);
           setIsSubmitting(false);
            setIsSuccess(true);
          } else if (res.data.status === 'failed') {
            clearInterval(interval);            
            setIsSubmitting(false);
            setIsSuccess(false);
             setIsFailed(true)

          }
        }, 10000); // Check every 10 seconds
      };

      const getCampaignSubaccount = async() => {
       
          const res = await makeGetRequest(`paystack-campaign-subaccount/${campaign?.id}`);
          if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);

        }else{
            setCampaignSubAccount(res.data.subAccountCode)
        }
       
      };


      const handlePaystackPayment = (donationData: any,paymentMethod:string) => {
        const paystack = new PaystackPop();
        const totalAmount = donationData.donationAmount * 100;
        const platformFee = totalAmount * 0.035; // 3.5% platform fee
        const tip = (donationData.tipAmount || 0) * 100;
        const campaignAmount = totalAmount - platformFee - tip;


      
           
        paystack.newTransaction({
            key: "pk_live_0fdba3598ab68189792f0f1cc0b7e81efc0ea334",
            email: donationData.email,
            amount: totalAmount,  // Exclude tip, Paystack handles only campaign funds
            currency: donationData.currency,
            channels: [paymentMethod],
           // subaccount: campaignSubAccount,  // Assign campaign’s subaccount
           // bearer: "subaccount",  // Ensure Paystack deducts fees from campaign funds
            transaction_charge: platformFee,  // FundReach’s 3.5% fee
            
            metadata: {
              donor: `${donationData.firstName} ${donationData.lastName}`,
              firstName: donationData.firstName,
              lastName: donationData.lastName,
              isAnonymous: donationData.isAnonymous,
              getUpdates: donationData.getUpdates,
              campaignId: donationData.campaignId,
              userId: donationData.userId,
              platformFee,  // 3.5% fee
              campaignAmount,  // Campaign share after platform fee deduction
              tipAmount: tip / 100,  // Tip is stored separately in metadata
              email: donationData.email,
              mobileNumber: donationData.mobileNumber
            },
          
            callback: (response: any) => {
              console.log("Payment completed!", response);
              finalizeDonation(response.reference);
            },
            
            onClose: () => alert("Payment canceled!"),
          });
      };

      
      const finalizeDonation = async (reference: string) => {
        try {
          const response = await makePostRequest("/donate/paystack/verify", { reference });
          if (response.data.status==='success') {
            //redirect to thank you page
           setIsSuccess(true)
          } else {
            alert("Failed to finalize donation");
          }
        } catch (error) {
          console.error("Error finalizing donation:", error);
          alert("An error occurred, please contact support.");
        }
      };
      
      
  

      // Refactored handleSubmit function to support credit card and bank payments with validation
const handleSubmit = async () => {
    setIsSubmitting(true);
    const data = {
      userId: isUserLoggedIn ? user.id : null,
      campaignId: campaign?.id,
      donationAmount,
      tipAmount,
      paymentMethod: payment,
      selectedCurrency,
      isAnonymous,
      getUpdates,
      bankName:selectedBank,

      ...userDetails,
    };

  
    // Base validations
    if (!donationAmount) return alert("Enter amount"), setIsSubmitting(false);
    if (!data.paymentMethod) return alert("Please select payment method"), setIsSubmitting(false);
    if (!selectedCurrency) return alert("Select your currency"), setIsSubmitting(false);
  
    // Payment method-specific validations
    if (currentPaymentMethod === "M-PESA" && (!data.mobileNumber || !data.firstName || !data.lastName)) {
      return alert("Please complete all M-PESA details"), setIsSubmitting(false);
    }

    if(currentPaymentMethod.toLocaleLowerCase() === "bank"){

        if(!campaignSubAccount){
            return alert("Sorry! This campaign does not support bank donations"), setIsSubmitting(false);
        }
        if ((!data.accountName || !data.accountNumber || !selectedBank)) {
            return alert("Please complete all bank details"), setIsSubmitting(false);
          }

          handlePaystackPayment({
            donationAmount:donationAmount,
            tipAmount:tipAmount,
            paymentMethod: payment,
            currency:selectedCurrency,
            isAnonymous:isAnonymous,
            getUpdates:getUpdates,
            userId: isUserLoggedIn ? user.id : null,
            campaignId:campaign?.id,
            ...userDetails,

        },'eft')

    }
  
    
    if(currentPaymentMethod.toLocaleLowerCase() === "credit or debit card"){
        if(!campaignSubAccount){
            return alert("Sorry! This campaign does not support bank donations"), setIsSubmitting(false);
        }

        if(!data.firstName || !data.lastName){
            return alert("Please enter your first and last names"), setIsSubmitting(false);

        }
        if(!data.email){
            return alert("Please enter your email"), setIsSubmitting(false);
        }
        if(!isEmail(data.email)){
            return alert("Enter a valid email address"), setIsSubmitting(false);
        }

        handlePaystackPayment({
            donationAmount:donationAmount,
            tipAmount:tipAmount,
            paymentMethod: payment,
            currency:selectedCurrency,
            isAnonymous:isAnonymous,
            getUpdates:getUpdates,
            userId: isUserLoggedIn ? user.id : null,
            campaignId:campaign?.id,
            ...userDetails,

        },'card')

     


    }

    if(currentPaymentMethod.toLocaleLowerCase() === "other mobile money"){

        if(!data.firstName || !data.lastName){
            return alert("Please enter your first and last names"), setIsSubmitting(false);

        }
        if(!data.email){
            return alert("Please enter your email"), setIsSubmitting(false);
        }
        if(!isEmail(data.email)){
            return alert("Enter a valid email address"), setIsSubmitting(false);
        }

        handlePaystackPayment({
            donationAmount:donationAmount,
            tipAmount:tipAmount,
            paymentMethod: payment,
            currency:selectedCurrency,
            isAnonymous:isAnonymous,
            getUpdates:getUpdates,
            userId: isUserLoggedIn ? user.id : null,
            campaignId:campaign?.id,
            ...userDetails,

        },'mobile_money')

    

       /* if (currentPaymentMethod === "credit or debit card" && (!data.cardNumber || !data.cardExpiry || !data.cardCvv || !data.cardName)) {
            return alert("Please complete all card details"), setIsSubmitting(false);
          }
          const isValidCreditCardNumber = validateCreditCard(data.cardNumber.toString());
          if(!isValidCreditCardNumber){
            return alert("Invalid  card number"), setIsSubmitting(false);
          }*/


    }
  
   
    
  
    try {
      const res = await makePostRequest("donate", data);
  
      if (isErrorObject(res)) {
        setIsSubmitting(false);
        const errorMessage = ErrorHandler(res);
        setError(errorMessage);
        alert(errorMessage);
      } else {
        const { approvalUrl, retryUrl, orderId, transactionId } = res.data;
  
        if (approvalUrl) {
          localStorage.setItem("orderId", orderId);
          window.location.href = approvalUrl;
        } else if (retryUrl) {
          const retry = window.confirm("Payment declined. Do you want to retry?");
          setRetryUrl(retryUrl);
          if (retry) window.location.href = retryUrl;
        } else if (transactionId) {
          checkPaymentStatus(transactionId);
        } else {
          alert("Something went wrong. Please try again.");
        }
      }
    } catch (error) {
      console.error("Donation error:", error);
      alert("An error occurred while processing your donation. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
};
     

    const getPaymentMethods = async () => {
        setIsLoading(true);
        const res = await makeGetRequest('payment-service-currencies');

        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {

            
            const results = res.data;
            setPaymentMethods(results);
            const defaultPaymentMethod = results && results.filter((paymentMethod:IPaymentMethod)=>paymentMethod.payment_service===currentPaymentMethod);
            setSupportedCurrencies(defaultPaymentMethod[0].currencies);
            setIsLoading(false);
            setError(null);
        }
    };

    
    const getBanks = async () => {
        setIsLoading(true);
        const res = await makeGetRequest('banks');

        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {
            const results = res.data;
            setBanks(results);       
            setIsLoading(false);
            setError(null);
        }
    };

    const getIcon = (payment_service: string) => {
        switch (payment_service) {
            case 'Google Pay':
                return <IconBrandGoogle size={iconSize} />;
            case 'Apple Pay':
                return <IconBrandApple size={iconSize} />;
            case 'Credit or debit':
                return <IconCreditCard size={iconSize} />;
            default:
                return <IconCreditCard size={iconSize} />;
        }
    };

    useEffect(() => {
        getPaymentMethods();
        getBanks();
        getCampaignSubaccount();
    }, []);

    useEffect(() => {
        if (isUserLoggedIn) {
            setShowGuestForm(true);
        }

    }, [isUserLoggedIn]);


    useEffect(() => {
        setTipAmount((tipPercentage / 100) * donationAmount); // Calculate tip when donation amount changes
    }, [tipPercentage,donationAmount]);

   //const navigate = useNavigate();

    if (isLoading) {
        return <Loader />;
    }

   else if (isSuccess) {
    const campaignId = campaign?.id;
    return <Navigate to='/donation-success' state={{
        amount:donationAmount,
        campaignId:campaignId,
        currency:selectedCurrency
    }}/>
   
    }
    else if (isFailed) {
       return <Navigate to="/payment-failed"/>
    } else{
        return (
            <Drawer
                position="bottom"
                title="Make a Donation"
                size="100%"
                scrollAreaComponent={ScrollArea.Autosize}
                {...others}
            >
                <Container>
                {retryUrl && (
                <button onClick={() => (window.location.href = retryUrl)}>
                    Retry Payment
                </button>
                )}
                    {error && <p className='error'>{error}</p>}
                    <Stack>

                        
                        <Flex gap="xs" align="center">
    
                            <img  src={campaign?.image} height={96} width={120}/>
                            <Text>You&apos;re supporting  <b>{campaign?.title}</b> </Text>
                        </Flex>

                        <Group mt="sm" spacing="xs">
                        {[50, 100, 200, 500, 1000].map((amount) => (
                        <Button
                            key={amount}
                            variant={donationAmount === amount ? 'filled' : 'outline'}
                            onClick={() => handlePresetClick(amount)}
                        >
                            ${amount}
                        </Button>
                        ))}
                        <p>You will choose your currency below after picking your payment method</p>
                    </Group>
                        <NumberInput
                            size="md"
                            label="Enter any amount"
                            precision={2}
                            rightSection={<IconCurrencyDollar size={iconSize} />}
                            value={donationAmount==0?"":donationAmount}
                            onChange={handleDonationAmountChange}
                            required
                        />


                     {
                        donationAmount>0 &&
                        <Paper {...paperProps}>
                        <Text fw={500}>Tip FundReach services</Text>
                        <Text size="sm" my="xs">FundReach has a 3.5% platform fee for organizers. FundReach will continue offering its services thanks to donors who will leave an optional amount here:</Text>
                        <Slider
                            marks={[
                                { value: 20, label: '20%' },
                                { value: 50, label: '50%' },
                                { value: 80, label: '80%' },
                            ]}
                            mb="lg"
                            onChange={handleTipAmountChange}
                        />
                    </Paper>
                     }

                     
                        <Paper {...paperProps}>
                            <Radio.Group
                                name="paymentMethod"
                                label="Payment method"
                                value={payment}
                                onChange={handlePaymentMethodChange}
                                mb="md"
                                required
                            >
                                <Group mt="sm">
                                {paymentMethods.map((method) => (
                        <Radio
                            key={method.id}
                            value={method.id} // Ensure unique values
                            label={<Group spacing="xs">{getIcon(method.payment_service)}<Text>{method.payment_service}</Text></Group>}
                            disabled={method.disabled}
                            //checked={payment === method.payment_service.toLowerCase().replace(/ /g, '')}
                            checked={method.payment_service===currentPaymentMethod}
    
                        />
                    ))}
                                  
                                 
                                </Group>
                            </Radio.Group>
                           {
                            supportedCurrencies &&
                            <Select
                            label="Currency"
                            value={selectedCurrency}
                            onChange={handleCurrencyChange}
                            data={supportedCurrencies.map(currency => ({ value: currency.cc, label: `${currency.symbol} ${currency.name}` }))}
                            required
                        />
                           }
    
    
                                {
                            currentPaymentMethod.toLocaleLowerCase()==="bank" &&
                          
    
                        
                        <Paper
                        p="md"
                        radius="sm"
                        mt="sm"
                    >
                        <Stack sx={{ width: '100%' }}>
                        <Group grow>
                        <Select
                            label="Your Bank"
                            value={selectedBank}
                            onChange={handleBankChange}
                            data={banks.map(bank => ({ value: bank.bank_name, label: `${bank.bank_name} ` }))}
                        />
    
                    <TextInput label="Account Name" name="accountName" value={userDetails.accountName} onChange={handleChange} />
                    <TextInput label="Account Number" name="accountNumber" value={userDetails.accountNumber} onChange={handleChange} />
                    <TextInput label="Email address" name="email" value={userDetails.email} onChange={handleChange} />
    
                            </Group>
    
                        </Stack>
    
    
                        </Paper>
                           }


<Transition
                                mounted={currentPaymentMethod.toLocaleLowerCase() === 'm-pesa'}
                                transition="scale-y"
                                duration={400}
                                timingFunction="ease"
                            >
                                {(styles) =>
                                    <Paper
                                        p="md"
                                        radius="sm"
                                        mt="sm"
                                        style={styles}
                                    >
                                        <Stack sx={{ width: '100%' }}>
                                            {showGuestForm && (
                                                <>
                                                   
                                                    <Group grow>
                                                        <TextInput label="First name" name="firstName" value={userDetails.firstName} onChange={handleChange} />
                                                        <TextInput label="Last name" name="lastName" value={userDetails.lastName} onChange={handleChange} />
                                                    </Group>
                                                   

                                                    <TextInput label="Mpesa Mobile Number" name="mobileNumber" value={userDetails.mobileNumber} onChange={handleChange} />
                                                    <TextInput label="Email address" name="email" value={userDetails.email} onChange={handleChange} />
                                                </>
                                            )}
    
                                            
                                          
                                        </Stack>
                                    </Paper>
                                }
                            </Transition>
    
    
    
    
    {
                            currentPaymentMethod.toLocaleLowerCase()==="m-pesax" &&
                          
    
                        
                        <Paper
                        p="md"
                        radius="sm"
                        mt="sm"
                    >
                        <Stack sx={{ width: '100%' }}>
                        <Group grow>
                      
    
                    <TextInput label="First name" name="firstName" value={userDetails.firstName} onChange={handleChange} />
                    <TextInput label="Last name" name="lastName" value={userDetails.lastName} onChange={handleChange} />
                                                    
                <TextInput label="Mpesa Mobile Number" name="mobileNumber" value={userDetails.mobileNumber} onChange={handleChange} />
                <TextInput label="Email address" name="email" value={userDetails.email} onChange={handleChange} />
    
                            </Group>
    
                        </Stack>


                        
    
    
                        </Paper>
                           }
    
                            <Transition
                                mounted={currentPaymentMethod.toLocaleLowerCase() === 'credit or debit card'}
                                transition="scale-y"
                                duration={400}
                                timingFunction="ease"
                            >
                                {(styles) =>
                                    <Paper
                                        p="md"
                                        radius="sm"
                                        mt="sm"
                                        style={styles}
                                    >
                                        <Stack sx={{ width: '100%' }}>
                                            {showGuestForm && (
                                                <>
                                                    <TextInput label="Email address" name="email" value={userDetails.email} onChange={handleChange} />
                                                    <Group grow>
                                                        <TextInput label="First name" name="firstName" value={userDetails.firstName} onChange={handleChange} />
                                                        <TextInput label="Last name" name="lastName" value={userDetails.lastName} onChange={handleChange} />
                                                    </Group>
                                                    <TextInput label="Mobile number" name="mobileNumber" value={userDetails.mobileNumber} onChange={handleChange} />
                                                </>
                                            )}
    
                                            
                                           {/* <Checkbox label="Use as billing name" />
                                            <NumberInput
                                                label="Card number"
                                                name="cardNumber"
                                                value={userDetails.cardNumber}
                                                onChange={(value) => handleNumberChange(value, 'cardNumber')}
                                            />
                                            <Group grow>
                                                <NumberInput
                                                    label="MM/YY"
                                                    name="cardExpiry"
                                                    value={parseInt(userDetails.cardExpiry) || 0}
                                                    onChange={(value) => handleChange({ target: { name: 'cardExpiry', value: value?.toString() || '' } } as any)}
                                                />
                                                <NumberInput
                                                    label="CVV"
                                                    name="cardCvv"
                                                    value={userDetails.cardCvv}
                                                    onChange={(value) => handleNumberChange(value, 'cardCvv')}
                                                />
                                            </Group>
                                            <TextInput label="Name on card" name="cardName" value={userDetails.cardName} onChange={handleChange} />
                                            <TextInput label="Postal code" name="postalCode" value={userDetails.postalCode} onChange={handleChange} />
                                            <Checkbox label="Save card for future donations" />*/}
                                        </Stack>
                                    </Paper>
                                }
                            </Transition>


                          

                            <Transition
                                mounted={currentPaymentMethod.toLocaleLowerCase() === 'other mobile money'}
                                transition="scale-y"
                                duration={400}
                                timingFunction="ease"
                            >
                                {(styles) =>
                                    <Paper
                                        p="md"
                                        radius="sm"
                                        mt="sm"
                                        style={styles}
                                    >
                                        <Stack sx={{ width: '100%' }}>
                                            {showGuestForm && (
                                                <>
                                                  
                                                    <Group grow>
                                                        <TextInput label="First name" name="firstName" value={userDetails.firstName} onChange={handleChange} />
                                                        <TextInput label="Last name" name="lastName" value={userDetails.lastName} onChange={handleChange} />
                                                    </Group>
                                                    <TextInput label="Contact Mobile number" name="mobileNumber" value={userDetails.mobileNumber} onChange={handleChange} />
                                                    <TextInput label="Email address" name="email" value={userDetails.email} onChange={handleChange} />
                                                </>
                                            )}
    
                                            
                                          
                                        </Stack>
                                    </Paper>
                                }
                            </Transition>
    
    
                            
                        </Paper>
                        <Paper {...paperProps}>
                            <Stack>
                                <Group spacing={4}>
                                    <Checkbox
                                        label="Don't display my name publicly on the fundraiser."
                                        checked={isAnonymous}
                                        onChange={(e) => setIsAnonymous(e.currentTarget.checked)}
                                    />
                                    <Popover width={200} position="bottom" withArrow shadow="md">
                                        <Popover.Target>
                                            <ActionIcon color="primary" variant="subtle">
                                                <IconInfoCircleFilled size={iconSize} />
                                            </ActionIcon>
                                        </Popover.Target>
                                        <Popover.Dropdown>
                                            <Text size="sm">Your name will only be visible to the organizer, any team members and the beneficiary</Text>
                                        </Popover.Dropdown>
                                    </Popover>
                                </Group>
                                <Checkbox
                                    label="Get occasional marketing updates from FundReach. You may unsubscribe at any time."
                                    checked={getUpdates}
                                    onChange={(e) => setGetUpdates(e.currentTarget.checked)}
                                />
                            </Stack>
                        </Paper>
                        <Paper {...paperProps}>
                            <Stack>
                                <Text fw={700} size="lg">Your donation</Text>
                                <Group position="apart">
                                    <Text>Your donation</Text>
                                    <Text fw={500}>{`${selectedCurrency} ${campaign?.currency===selectedCurrency ? donationAmount.toFixed(2):(donationAmount).toFixed(2)}`}</Text>
                                </Group>
    
                                <Group position="apart">
                                    <Text>Platform fee</Text>
                                    <Text fw={500}>{`${selectedCurrency} ${campaign?.currency===selectedCurrency ? (donationAmount*serviceFee).toFixed(2):((donationAmount*serviceFee)).toFixed(2)}`}</Text>
                                </Group>
                                <Group position="apart">
                                    <Text>Beneficiary Amount</Text>
                                    <Text fw={500}>{`${selectedCurrency} ${campaign?.currency===selectedCurrency?(donationAmount-(donationAmount*serviceFee)).toFixed(2):
                                    ((donationAmount)-((donationAmount*serviceFee))).toFixed(2)
                                        
                                 }`}</Text>
                                </Group>
    
                                <Group position="apart">
                                    <Text>FundReach tip</Text>
                                    <Text fw={500}>{`${selectedCurrency} ${campaign?.currency ===selectedCurrency ? tipAmount && tipAmount.toFixed(2):(tipAmount ).toFixed(2)}`}</Text>
                                </Group>
    
                                <Group position="apart">
                                    <Text>Total due </Text>
                                   
                                    <Text fw={500}>
                                        {`${selectedCurrency} ${campaign?.currency===selectedCurrency ? ((donationAmount + tipAmount)).toFixed(2):((donationAmount + tipAmount)).toFixed(2)}`}
    
                                    </Text>
                                </Group>
                                {/*<Button size="lg" onClick={handleSubmit} loading={isSubmitting}>Donate Now</Button>*/}

                                <Button
                                leftIcon={currentPaymentMethod === 'PayPal'  &&<FaPaypal size={20} />}
                                size="lg"
                                onClick={handleSubmit}
                                loading={isSubmitting}
                                color={currentPaymentMethod === 'PayPal' ? 'yellow' : 'blue'}
                                style={currentPaymentMethod === 'PayPal' ? { backgroundColor: '#FFC439', color: '#111' } : {}}
                                >
                                {currentPaymentMethod === 'PayPal' ? 'Continue to PayPal' : 'Donate Now'}
                                </Button>
                            </Stack>
                        </Paper>
                        <Paper {...paperProps}>
                            <Stack>
                                <Text size="sm">By continuing, you agree with <Link to="/terms">FundReach terms</Link> and <Link to="/privacy">privacy notice.</Link></Text>
                                
                            </Stack>
                        </Paper>
                    </Stack>
                </Container>
            </Drawer>
        );
    }

   
};

export default DonationDrawer;
